



















































import { watch, defineComponent, toRefs, computed, onMounted, getCurrentInstance } from '@vue/composition-api';

// 引入组件
import Empty from '@/renderer/components/drawer/components/Empty/index.vue';
import i18n, { i18n_t } from '@/locales/i18n';

// 引入 compositions
import historyHandler from '@/renderer/components/SpacePage/compositions/historyHandler';
import downloadHandler from '@/renderer/components/SpacePage/compositions/downloadHandler';
import openPreviewHandler from '@/renderer/components/SpacePage/compositions/openPreviewHandler';

// 引入工具类
import { PAY_SOURCE, openTeamPayDialog } from '@/renderer/scripts/composition/dialogHandler';
import { isChinese, checkToNumber } from '@/renderer/scripts/utils/tools/index';
import { isAllowPreviewImage, isAllowPrivate, isAllowEditDoc } from '@/renderer/scripts/composition/allowPreview';
import ConstantConfig from '@/renderer/scripts/utils/ConstantConfig';
import tips from '@/renderer/scripts/utils/tips';
import { SMH } from '@/renderer/scripts/smh';
import historyItem from './HistoryItem.vue';
export default defineComponent({
  components: {
    historyItem,
    Empty,
  },
  name: 'History',
  props: {
    params: {
      required: true,
      type: Object as () => Drawer.HistoryParams<SMH.HistoryItem>,
    },
    pageData: {
      type: Object,
      default: () => ({
        currPage: 1,
        pageSize: 20,
      }),
    },
  },
  setup(props, context) {
    const vm = getCurrentInstance()?.proxy || context.root;
    const store = context.root.$store;
    const { params } = toRefs(props);
    const spaceId = computed(() => params.value.spaceId);
    const data = computed(() => params.value.selectedItem);
    const {
      curHistoryId,
      loading: historyLoading,
      list: historyList,
      methods: historyMethods,
      historyConfig,
    } = historyHandler(spaceId);
    const { methods: downloadMethods } = downloadHandler(spaceId);
    const { methods: previewMethods } = openPreviewHandler(spaceId);
    const map: Record<number, string> = {
      0: i18n_t('创建'),
      1: i18n_t('更新'),
      2: i18n_t('恢复'),
    };
    const checkAll = computed(
      () => historyList.value.length > 1 && historyList.value.every((i: any) => i.check.value || i.isLatestVersion),
    );
    const indeterminate = computed(
      () => historyList.value.some((i: any) => i.check.value) && !historyList.value.every((i: any) => i.check.value),
    );
    const checkedNum = computed(() => historyList.value.filter((i: any) => i.check.value).length);
    const isOnlyLatestVersion = computed(() => historyList.value.filter(i => !i.isLatestVersion).length === 0);

    // 当购买了企业版之后才发送请求
    const hasBuyTeam = computed(() => store.getters.editionFlag !== 'personal');
    !hasBuyTeam &&
      reporter.report('pay', {
        pay_source_show: 'details_history_tips',
      });
    const methods = {
      handleSelectAll(checked: boolean) {
        for (let index = 0; index < historyList.value.length; index++) {
          (historyList.value[index] as any).check.value = !historyList.value[index].isLatestVersion ? !!checked : false;
        }
      },
      initData() {
        // 拥有团队版 才可以查询
        if (!hasBuyTeam.value) {
          historyLoading.value = false;
          return;
        }
        // 企业 B 成员要访问企业 A 的 doc 文件，应该这样传：
        // /user/v1/history-list/orgIdB/spaceIdA/doc?space_org_id=A
        const routerSpaceOrgId = checkToNumber(vm.$route.query?.spaceOrgId);
        historyMethods.pullHistoryList({
          ...data.value,
          spaceOrgId: routerSpaceOrgId || vm.$store.getters.orgId,
        });
        if (historyList.value.length === 0) {
          historyMethods.getHistoryConfig();
        }
      },
      async onHistoryOperate(action: string, item?: any) {
        switch (action) {
          case 'setLatest':
            historyMethods.setLatestVersion(item);
            break;
          case 'delete':
            historyMethods.deleteHistory(item.length ? item : [item]);
            break;
          case 'download':
            item.type = 'file';
            downloadMethods.prepareDownload([item]);
            break;
          case 'preview':
            if (isAllowPreviewImage(item.name) && item.size >= ConstantConfig.ciImageMaxSize) {
              // 万象最大支持32mb
              tips.error(i18n_t('文件过大，请下载至本地查看'));
            } else if (!store.getters.enableDocPreview && !isAllowPrivate(item.name)) {
              if (isAllowEditDoc(item.name)) {
                tips.error(i18n_t('当前文件暂未接入文档预览与编辑服务，请下载至本地查看'));
              } else {
                tips.error(i18n_t('该文件暂不支持预览，请下载至本地查看'));
              }
            } else {
              previewMethods.openPreview(item, 1, {
                historyId: item.id,
                isHistoryVersion: !item.isLatestVersion,
              });
            }
            break;
          default:
            break;
        }
      },
    };
    onMounted(() => methods.initData());
    watch(data, val => {
      if (val) {
        methods.initData();
      }
    });
    const handlerBuy = () => {
      openTeamPayDialog(PAY_SOURCE.HISTORY_DRAWER);
    };
    return {
      map,
      checkAll,
      indeterminate,
      checkedNum,
      ...methods,
      historyList,
      isChinese,
      curHistoryId,
      historyLoading,
      hasBuyTeam,
      handlerBuy,
      historyConfig,
      isOnlyLatestVersion,
    };
  },
});
